import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import { I18nProvider } from "./lib/i18n.tsx";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root"); // i18n-ignora: errore di programmazione

createRoot(root).render(
  <StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </StrictMode>,
);
